export default [
  { title: 'About', to: '/about' },
  { title: 'Contact', to: '/contact' },
  { title: 'Blog', to: '#!' },
  { title: 'Terms', to: '#!' },
  { title: 'Privacy', to: '#!' },
];
